import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57a2afef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MainComponentsMain" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "menu-container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "metaTitle" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "metaTitle",
  style: {"padding-right":"20px"}
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  class: "parent",
  style: {"margin-left":"8px"}
}

import { ref, onMounted, toRaw, nextTick, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getAuditNum } from "@/views/Login/api.js";
import { getAssetsFile } from "@/utiles/utiles";

export default /*#__PURE__*/_defineComponent({
  __name: 'componentMain',
  props: ["isCollapse"],
  setup(__props) {

const { isCollapse } = __props;

const store = useStore();

let promiseRoute = store.getters.menu;
const routerArr = ref<any>([]);
const openeds = ref<string[]>([]);
const defaultActive = ref<string>("");
const Router = useRouter();
watch(
  () => toRaw(Router).currentRoute.value.name,
  (newName) => {
    if (newName) {
      defaultActive.value = newName.toString();
    }
  }
);
const showMenu = ref<boolean>(false);
onMounted(async () => {
  // await store.dispatch('GetMenu')
  let name = toRaw(Router).currentRoute.value.name || "";
  defaultActive.value = name.toString();
  await nextTick();
  getRouter();
  getAllAuditNum();
  console.log("store.state.auditNum", store.state.auditNum);
  console.log("openeds", openeds.value);
});
const getRouter = () => {
  console.log("Router", Router);
  const { userType, userRole } = JSON.parse(
    sessionStorage.getItem("userInfo") || ""
  );
  let arr =
    Router.options.routes.filter((item) => {
      return item.name === "main";
    })[0].children || [];
  console.log("arr1", arr);
  console.log("store.getters.menu", store.getters.menu);
  promiseRoute = flatPromissRouter(store.getters.menu).flat(2);
  console.log("promiseRoute", promiseRoute);
  // return
  arr = flatRouter(JSON.parse(JSON.stringify(arr)));
  console.log("arr3", arr);

  if (arr?.length) {
    routerArr.value = arr;
    openeds.value = getNames(routerArr.value);
    // 显示菜单
    showMenu.value = true;
  }

  console.log("routerArr", arr);
};
const getAllAuditNum = () => {
  getAuditNum().then((res: any) => {
    store.commit("SET_AUDITNUM", res);
  });
};
const onSelect = (index: string) => {
  console.log("选中了菜单项：", index);
  // 在这里你可以根据 index 的值来执行相应的逻辑
};
const getNames = (arr: any[]): string[] => {
  const traverse = (items: any[]): string[] =>
    items.reduce<string[]>((acc, item) => {
      if (item.name) {
        acc.push(item.name.toString()); // 确保 name 是字符串
      }
      if (item.children) {
        acc.push(...traverse(item.children));
      }
      return acc;
    }, []);
  return traverse(arr);
};

const flatRouter = (arr: any[]) => {
  let result = arr.filter((v: any) => {
    if (v.children && Array.isArray(v.children)) {
      v.children = flatRouter(v.children);
    }

    if (v.name == "Home") {
      return true;
    }
    // if(Array.isArray(v.children) && v.children.length === 0){
    //   return false
    // }
    return v.meta && v.meta.id ? promiseRoute.includes(v.meta.id) : false;
  });
  // console.log('result', result);

  return result;
};
const flatPromissRouter = (arr: any[]) => {
  return arr.map((v: any) => {
    if (Array.isArray(v.children)) {
      return [...flatPromissRouter(v.children), v.id];
    }
    return v.id;
  });
};
const selectMenu = (item: any) => {
  Router.push({ name: item.name });
};
const shouldShowDot = (item: any) => {
  let auditNum = store.state.auditNum;
  let result =
    (item.meta.id === "12" &&
      auditNum.orderAuditNum &&
      auditNum.orderAuditNum > 0) ||
    (item.meta.id === "15" &&
      auditNum.caseAuditNum &&
      auditNum.caseAuditNum > 0);
  return result;
};

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!__props.isCollapse)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "养殖险验标系统"))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            style: {"width":"100%","height":"100%"},
            src: require(`../../../assets/image/app_icon.png`)
          }, null, 8, _hoisted_4))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_scrollbar, null, {
        default: _withCtx(() => [
          (showMenu.value)
            ? (_openBlock(), _createBlock(_component_el_menu, {
                key: 0,
                "default-active": defaultActive.value,
                "popper-effect": "light",
                class: "el-menu-vertical-demo",
                "default-openeds": openeds.value,
                collapse: __props.isCollapse
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routerArr.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      (!item.children && item.isMenu)
                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                            key: 0,
                            index: item.name,
                            onClick: ($event: any) => (selectMenu(item))
                          }, {
                            title: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, _toDisplayString(item.meta.title), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                style: {"width":"20px","height":"20px"},
                                src: require(`../../../assets/image/${item.meta.icon}.svg`)
                              }, null, 8, _hoisted_6)
                            ]),
                            _: 2
                          }, 1032, ["index", "onClick"]))
                        : _createCommentVNode("", true),
                      (item.children)
                        ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                            key: 1,
                            index: item.name
                          }, {
                            title: _withCtx(() => [
                              _createElementVNode("img", {
                                style: {"width":"20px","height":"20px"},
                                src: require(`../../../assets/image/${item.meta.icon}.svg`)
                              }, null, 8, _hoisted_8),
                              (!__props.isCollapse)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.meta.title), 1))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (value, i) => {
                                return (_openBlock(), _createBlock(_component_el_menu_item, {
                                  key: i,
                                  index: value.name,
                                  class: _normalizeClass({ 'extra-padding': value.meta.id === '21' }),
                                  onClick: ($event: any) => (selectMenu(value))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      style: {"width":"20px","height":"20px"},
                                      src: require(`../../../assets/image/${value.meta.icon}.svg`)
                                    }, null, 8, _hoisted_10),
                                    _createElementVNode("div", _hoisted_11, [
                                      _createElementVNode("span", null, _toDisplayString(value.meta.title), 1),
                                      _createElementVNode("div", {
                                        class: _normalizeClass({ 'is-dot': shouldShowDot(value) })
                                      }, null, 2)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["index", "class", "onClick"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["index"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["default-active", "default-openeds", "collapse"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})